import * as React from 'react';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';

import SamlSsoApplication from './SamlSsoApplication';

const SamlLoginPage = loadOnRoute(() => import('bundles/saml-sso/components/SamlLoginPage'));
const SSOReturnPage = loadOnRoute(() => import('bundles/saml-sso/components/SSOReturnPage'));
const RecoveryEmailPage = loadOnRoute(() => import('bundles/saml-sso/components/RecoveryEmailPage'));
const ResetConfirmPage = loadOnRoute(() => import('bundles/saml-sso/components/account-recovery/AccountRecovery'));
const SSORedirectPage = loadOnRoute(() => import('bundles/saml-sso/components/SSORedirectPage'));
const RecoveryEmailVerification = loadOnRoute(() => import('bundles/saml-sso/components/RecoveryEmailVerification'));
const AccountMerge = loadOnRoute(() => import('bundles/saml-sso/components/account-merge/AccountMerge'));

const routes = (
  <CourseraRoute path="/" component={SamlSsoApplication}>
    <CourseraRoute path="sso">
      <CourseraRoute
        path="recovery-email"
        getComponent={RecoveryEmailPage}
        handle={{
          tracking: {
            data: (_, location) => ({
              page: { segment: 'enterprise', type: 'recovery_email' },
              ...(location.query.orgSlug && { enterprise: { organizationSlug: location.query.orgSlug } }),
            }),
          },
        }}
      />
      <CourseraRoute path="redirect" getComponent={SSORedirectPage} />
      {/* NOTE - Tracking for this route is handled inside the component */}
      <CourseraRoute path="return/:method/:token" getComponent={SSOReturnPage} />
      <CourseraRoute
        path="recover-account/:token"
        getComponent={ResetConfirmPage}
        handle={{
          tracking: {
            data: (_, location) => ({
              page: { segment: 'enterprise', type: 'recover_account' },
              ...(location.query.orgSlug && { enterprise: { organizationSlug: location.query.orgSlug } }),
            }),
          },
        }}
      />
      <CourseraRoute path="return" getComponent={SSOReturnPage} />
      <CourseraRoute path="account-merge" getComponent={AccountMerge} />
      <CourseraRoute path=":slug" getComponent={SamlLoginPage} />
      <CourseraRoute path="verify-recovery-email/:token" getComponent={RecoveryEmailVerification} />
    </CourseraRoute>
  </CourseraRoute>
);

export default routes;
